import PageWithTabs from "components/PageWithTabs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LoadingOverlay from "components/blocks/LoadingOverlay";
import useSystemDateTheme from "hooks/useSystemDateTheme";
import { myWorkStatusClassNames } from "../MyUnsignedWorkGridView";
import AboutProgramTab from "views/home/programs/ViewProgram/tabs/AboutProgramTab";
import {useCallback, useEffect, useRef, useState} from "react";
import { ProgramByIDResponse } from "services/programs/models/ProgramTypes";
import { useNotification } from "hooks/useNotification";
import { ProgramsService } from "services/programs";
import { useCookieContext } from "contexts";
import { OrderStatus } from "../../../../../shared/lookups";
import {useQuery} from "../../../../../hooks/useQuery";
import {OrdersService} from "../../../../../services/orders";
import {OrderInfoTab} from "../../../orders/OrderView/Tabs/OrderInfoTab";
import {OrderActivePages, OrderUserTypes} from "../../../orders/OrderView";
import {
  EvaluateProgramUpdateRef
} from "../../../orders/OrderView/Tabs/OrderInfoTab/components/Updates/useProgramOrderUpdateActions";
import {ApproveByCenterManagerSubmitHandlerRef} from "../../../orders/OrderView/PageActions/useCloseRequestActions";

const MyUnsignedWorkView = () => {
  // Hooks
  const { t } = useTranslation("Programs");
  const { isAr } = useCookieContext();
  const { toSystemThemeDateFormat } = useSystemDateTheme();
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState<keyof typeof OrderActivePages>( "Default");
  const programUpdateHandlersRef = useRef<EvaluateProgramUpdateRef>(null);
  const approveByCenterManagerSubmitHandlerRef = useRef<ApproveByCenterManagerSubmitHandlerRef>(null);
  // State
  const { data: order, loading } = useQuery({
    queryFn: async () => {
      return await OrdersService.getOneById(+orderId!);
    },
    options: {
      enabled: !!orderId,
    },
    triggers: [orderId],
    onError: () => {
      navigate(-1);
    },
    initialLoading: !!orderId,
  });

  //Program Api
  const { data: programData, loading: programLoading } = useQuery({
    queryFn: async () => {
      const id = order?.programId ? order.programId : 0;

      return await ProgramsService.getProgramById(id);
    },
    triggers: [order?.programId],
    options: { enabled: !!order?.programId },
  });

  const programName = programData
    ? `${programData?.programDetails.find((x) => x.locale === (isAr ? "Ar" : "En"))?.displayName}`
    : "";

  return (
    <>
      <PageWithTabs
        title={<div className="d-flex gap-3">{programName}</div>}
        subTitle={` ${t("Orders:programNumber")}: ${programData?.serialNumber}`}
        loading={programLoading || loading}
        pageHeaders={[
          {
            title: t("OrdersUnsignedWork:orderNumber"),
            value: order?.serialNumber ?? "",
          },
          {
            title: t("OrdersUnsignedWork:submissionDate"),
            value: toSystemThemeDateFormat(order?.createdOn),
          },
          {
            title: t("OrdersUnsignedWork:researchCenter"),
            value: order?.centreManagement?.displayName ?? "",
          },
          {
            title: t("OrdersUnsignedWork:orderPhase"),
              value: order?.orderPhase ?? "",
          },
        ]}
        actions={(selectedTabId) => {
          return (
            <span className={`badge rounded-4 ${myWorkStatusClassNames[order?.orderStatusId ?? OrderStatus.Inprogress] as string} py-2`}>
              {order?.orderStatus}
            </span>
          );
        }}
        tapContent={
          <>
            {loading && <LoadingOverlay visible={loading} />}
            <OrderInfoTab
                order={order}
                orderProgram={programData}
                userType={"UnsignedResearcher"}
                activePage={activePage}
                setActivePage={setActivePage}
                openedTask={null}
                programUpdateHandlersRef={programUpdateHandlersRef}
                 approveByCenterManagerSubmitHandlerRef={approveByCenterManagerSubmitHandlerRef}
                // setTriggerOrderUpdate={setTriggerOrderUpdate}
            />
            {/*{!loading && !!programData && <AboutProgramTab program={programData} />}*/}
          </>
        }
      />
    </>
  );
};

export default MyUnsignedWorkView;
